import React, { useEffect, useMemo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AUTH_CONSTANTS } from 'utils/constants';
import styles from './ReceiptImageTab.module.scss';

/**
 * Full-tab receipt preview on the hub origin (e.g. hub.abrasoft.com): dark canvas, single image.
 * Image bytes load from the API `/transactions/receipt-image/view` (Bearer not required).
 */
function ReceiptImageTab() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const hasRedirectedRef = useRef(false);

  const src = useMemo(() => {
    if (!token?.trim()) return null;
    const base = AUTH_CONSTANTS.API_BASE_URL.replace(/\/+$/, '');
    if (!base) return null;
    return `${base}/transactions/receipt-image/view?token=${encodeURIComponent(token.trim())}`;
  }, [token]);

  useEffect(() => {
    const prev = document.title;
    document.title = 'Receipt';
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevBodyMargin = body.style.margin;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    body.style.margin = '0';
    return () => {
      document.title = prev;
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      body.style.margin = prevBodyMargin;
    };
  }, []);

  if (!src) {
    return <div className={styles.root} />;
  }

  return (
    <div className={styles.root}>
      <img
        src={src}
        alt=""
        className={styles.img}
        onLoad={() => {
          if (hasRedirectedRef.current) return;
          hasRedirectedRef.current = true;
          window.location.replace(src);
        }}
      />
    </div>
  );
}

export default ReceiptImageTab;
